import manager from '../manager'
import $ from 'jquery'
import _ from 'lodash'



manager.add('size.em', {
	created(designWidth=750,rootFontSize=16) {
        this.resize=_.debounce(()=>{
            let currentFontSize=$(this.dom).width()/designWidth*rootFontSize
            $(this.dom).css({"font-size":currentFontSize+"px"})
        },50)
        this.resize()
        $(window).on('resize',this.resize);
    },
    destroyed(){
        $(window).off('resize',this.resize);
    }
})